module.exports = __webpack_public_path__ + "img/guangda copy.9b3b76a8.png";